module.exports = __webpack_public_path__ + "img/gratuito.954862f5.png";